<template>
  <v-container >
    <entity-properties-row :label="$t('serviceRequest.location')"
                           :property="serviceRequest.location | location">
    </entity-properties-row>
    <entity-properties-row :label="$t('device.singular')"
                           :property="serviceRequest.device| device">
    </entity-properties-row>
    <entity-properties-row :label="$t('serviceRequest.message')">
      <preformatted-text-view v-model="serviceRequest.message"/>
    </entity-properties-row>
    <entity-properties-row :label="$t('serviceRequest.availabilityWindow')">
        <div>{{serviceRequest.serviceWindowStart | date | ellipsisMissing}} - {{serviceRequest.serviceWindowEnd | date | ellipsisMissing}} </div>
    </entity-properties-row>
    <entity-properties-row :label="$t('serviceRequest.reportingUser')"
                           :property="serviceRequest.reportingUser | user">
    </entity-properties-row>
    <entity-properties-row :label="$t('serviceRequest.inviter')"
                           :property="serviceRequest.inviter">
    </entity-properties-row>

    <entity-properties-row :label="$t('serviceRequest.state')"
                           :property="serviceRequest.state | serviceRequestState">
    </entity-properties-row>

    <slot name="append"></slot>
  </v-container>
</template>

<script>
import EntityPropertiesRow from '@/components/entity-crud/EntyPropertiesRow';
import PreformattedTextView from '@/components/layouts/PreformattedTextView';

export default {
  name: 'ServiceRequestPropertiesView',
  components: { PreformattedTextView, EntityPropertiesRow },
  props:{
    serviceRequest: {
      required:true,
      type: Object,
    },
  },
};
</script>

<style scoped>

</style>
